import React from "react";

import { isOpenableDocumentUrl } from "../../../../utils/documentLinks";

interface DocumentReferenceProps {
  reference: string;
}

/**
 * A stored contract document address. Addresses that open in a browser are
 * offered as links; the rest are shown as selectable text, because since
 * contracts moved to the document store those addresses are private and a link
 * would give every agent an error page (FR-013). Either way the text stays
 * selectable — it is exactly what gets pasted into "Confirm signed".
 */
const DocumentReference: React.FC<DocumentReferenceProps> = ({ reference }) =>
  isOpenableDocumentUrl(reference) ? (
    <a
      href={reference}
      target="_blank"
      rel="noopener noreferrer"
      style={{ wordBreak: "break-all" }}
      title={reference}
    >
      {reference}
    </a>
  ) : (
    <span
      style={{ wordBreak: "break-all", userSelect: "all" }}
      title={reference}
    >
      {reference}
    </span>
  );

export default DocumentReference;
